import { Button, Grid, Typography, useMediaQuery } from '@mui/material'
import { Icon, FixedLogo } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { RoutingStore } from 'stores'
import { theme } from 'config'

const image = require('assets/images/background.jpg')

export interface IAuthenticationProps {
  routingStore?: RoutingStore,
}

export const HomePage = inject('routingStore')(observer((props: IAuthenticationProps) => {
  const { routingStore } = props;
  const isNotMobileView  = useMediaQuery(theme.breakpoints.up('sm'));
  const { t } = useTranslation();

  return (
    <>
      <FixedLogo color={theme.palette.white.main}/>
      <Grid
        container
        direction      = 'column'
        alignItems     = 'center'
        justifyContent = 'center'
        width          = '100%'
        minHeight      = '100vh'
        sx             = {{
          background:     `linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.7)), url(${image}) no-repeat center center fixed`,
          backgroundSize: 'cover'
        }}
      >
        <Typography textAlign='center' mb={isNotMobileView ? 5 : 3} color={theme.palette.primary.contrastText} variant={isNotMobileView ? 'h1' : 'h3'}>
          {t('welcome_text_homepage')}
        </Typography>
        <Button
          onClick   = {() => routingStore.push(RoutingStore.loginPage)} 
          variant   = 'contained'
          color     = 'primary'
          endIcon = {<StyledIcon iconId='arrow-left' />}
        >
          {t('homepage_login_text')}
        </Button>
      </Grid>
    </>
  );
}));

const StyledIcon = styled(Icon)`
  transform: rotate(180deg);
`